import * as React from 'react';
import { Dayjs } from 'dayjs';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

interface Props {
    date : Dayjs | null;
    setDate : (date: Dayjs | null) => void;
    label : string;
    isDisabled?: boolean;
    customSx?: object;
    // Hosts that draw their own field label (the IRA search bar) suppress the
    // floating MUI label — it renders on top of the input's mask placeholder
    // and reads as doubled text. The mask placeholder still shows the format.
    hideFloatingLabel?: boolean;
}

export const CustomDatePicker: React.FC<Props> = ({date,setDate,label,isDisabled,customSx,hideFloatingLabel}) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                disabled={isDisabled}
                label={hideFloatingLabel ? undefined : label}
                value={date}
                onChange={(newValue) => {
                    setDate(newValue);
                }}
                renderInput={(params) => <TextField sx={{
                    cursor: isDisabled ? 'not-allowed' : 'text',
                    '& .MuiInputBase-input': {
                        cursor: isDisabled ? 'not-allowed' : 'text',
                    },
                    ...customSx
                }} {...params}/>}
            />
        </LocalizationProvider>
    )
}